import Vue from 'vue'
import store from '../vuex'

export const userService = {
  login,
  loginRemember,
  logout,
  get,
  getBasic,
  update,
  register,
  exists,
  activate,
  requestPassword,
  resetPassword
}

function login (account) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/login'), account)
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function loginRemember (userId, hash) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/login-remember'), {
      userId: userId,
      hash: hash
    })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function logout () {
  store.commit('resetTokens')
}

function get () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/user'))
      .then(response => {
        let data = response.data.data
        if (data.store_logo) {
          data.store_logo = Vue.prototype.$hostname.concat('/image/user/').concat(store.state.userId).concat('/logo/').concat(data.store_logo)
        }
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getBasic (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/user/' + id))
      .then(response => {
        let data = response.data.data
        if (data.store_logo) {
          data.store_logo = Vue.prototype.$hostname.concat('/image/user/').concat(data.user_id).concat('/logo/').concat(data.store_logo)
        }
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function update (account) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/user'), account)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function register (account) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/register'), account)
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function exists (email) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/check'), { email: email })
      .then(response => {
        resolve(true)
      })
      .catch(error => {
        if (error.response.status === 400) {
          resolve(false)
        } else {
          reject(error)
        }
      })
  })
}

function activate (email, token) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/activate'), { email: email, token: token })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function requestPassword (email) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/requestpassword'), { email: email })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function resetPassword (email, token, password) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/resetpassword'), { email: email, token: token, password: password })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/user.service.js